export default __webpack_public_path__ + "static/media/stake-more-rfuel.c37db18e.svg";